export const keys = {
  agmApiKey: 'AIzaSyDhqULnQd2wDeksocTFlZAigQ9SOw8ff9I',
};
